export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const levels = [
    { icon: 'ri-emotion-happy-line', level: 'Реакция', desc: 'Понравилось ли обучение участникам' },
    { icon: 'ri-book-open-line', level: 'Знания', desc: 'Что сотрудники усвоили' },
    { icon: 'ri-user-settings-line', level: 'Поведение', desc: 'Что изменилось в работе' },
    { icon: 'ri-line-chart-line', level: 'Бизнес-результат', desc: 'Рост продаж, прибыли, KPI' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20professional%20corporate%20training%20evaluation%20analytics%20dashboard%20with%20holographic%20data%20visualization%2C%20clean%20minimalist%20dark%20background%2C%20teal%20and%20golden%20abstract%20geometric%20elements%2C%20sophisticated%20business%20intelligence%20interface%2C%20glowing%20performance%20metrics%20charts%2C%20professional%20corporate%20aesthetic%2C%20elegant%20data%20overlays%2C%20editorial%20quality&width=1600&height=900&seq=evaluation-hero-01&orientation=landscape"
          alt="Оценка эффективности корпоративного обучения — аналитика и KPI"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/75 to-black/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-3 leading-tight">
              Оценка эффективности обучения персонала
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-teal-300 mb-5 leading-snug">
              Обучение сотрудников должно приносить прибыль, а не просто хорошие отзывы
            </p>
            <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-xl">
              Большинство компаний оценивают обучение по эмоциям участников. Но настоящий показатель — изменения в поведении сотрудников, рост KPI и влияние на прибыль компании. Я помогаю не просто проводить обучение, а измерять его эффективность.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                Рассчитать эффективность обучения
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                Заказать корпоративное обучение
                <i className="ri-phone-line"></i>
              </button>
            </div>
          </div>

          <div className="flex flex-col items-center lg:items-end gap-6">
            {/* 4 levels infographic */}
            <div className="w-full max-w-sm space-y-3">
              <h3 className="text-white/60 text-sm font-semibold uppercase tracking-wider text-center lg:text-right">
                4 уровня оценки обучения
              </h3>
              {levels.map((l, i) => (
                <div key={i} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/15 hover:bg-white/15 transition-all">
                  <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${l.icon} text-lg text-white`}></i>
                  </div>
                  <div>
                    <div className="text-white font-bold text-sm">Уровень {i + 1}: {l.level}</div>
                    <div className="text-white/60 text-xs">{l.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}